import { Injectable } from "@angular/core";
import { Observable, Observer, Subject } from 'rxjs';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import { map } from 'rxjs/operators';
import { io } from 'socket.io-client';

import { CONSTANTS } from "../constants";
import { DataService } from "./data.service";

@Injectable()
export class SocketService {

    private subject: AnonymousSubject<MessageEvent> | null = null;
    private token: string | null;
    private socket: any;
    private instrument_subscribed = 0;
    private subscribers: any = {};
    private connection_init_subs: any = {};

    public messages: Subject<any>;

    constructor(private dataService: DataService) {}

    public init_connection() {
        this.token = sessionStorage.getItem(CONSTANTS.COOKIE.HEADER_TOKEN);
        let details = this.dataService.retrieveLiveSocketDetails();
        let url = details.socket_url || CONSTANTS.API.FEED_SOCK_URL;
        this.messages = <Subject<any>>this.connect(url).pipe(
            map(
                (response: any) => {
                    try {
                        return response;
                    } catch (e) {
                        console.log(`Error parsing response => ${e}`)
                    }
                    return response;
                }
            )
        );
        this.messages.subscribe(msg => {
            // console.log("msg => " + msg);
            if (msg.event == 'connect') {
                this.sendConnectionInit();
                this.subscribe_instrument_updates(details);
            } else if (msg.event == 'disconnect') {
            } else if (msg.event == 'ticks') {
                this.sendMessages(msg.data);
            }
        });
    }

    private subscribe_instrument_updates(details: any) {
        if (this.instrument_subscribed == 0) {
            this.messages.next({event:'subscribe', msg:{ bname: details.bname, token:details.tokens}});
            this.instrument_subscribed = 1;
        }
    }

    public close_connection() {
        this.socket.disconnect();
        this.subject = null;
    }

    public connect(url: any): AnonymousSubject<MessageEvent> {
        if (!this.subject) {
            this.subject = this.create(url);
            console.log("Successfully connected: " + url);
        }
        return this.subject;
    }

    private create(url: any): AnonymousSubject<any> {
        this.socket = io(url, {path: '/qpnl_sock/', transports: ['websocket', 'polling'], query: { token: this.token } });
        let observable = new Observable((obs: Observer<any>) => {
            this.socket.on('connect', (data: any) => {
                obs.next({event: 'connect', data: data});
            });
            this.socket.on('disconnect', (data: any) => {
                obs.next({event: 'disconnect', data: data});
            });
            this.socket.on('ticks', (data: any) => {
                obs.next({event: 'ticks', data: data});
            });
            return () => {
                this.socket.disconnect();
            }
        });
        let observer: any = {
            error: null,
            complete: null,
            next: (data: any) => {
                this.socket.emit(data.event, data.msg);
            }
        };
        return new AnonymousSubject<any>(observer, observable);
    }

    priceUpdate(key: any, subscriber: any) {
        this.subscribers[key] = subscriber;
    }

    onConnectionInit(key: any, subscriber: any) {
        this.connection_init_subs[key] = subscriber;
    }

    sendConnectionInit() {
        for (let key in this.connection_init_subs) {
            let subscriber = this.connection_init_subs[key];
            if (subscriber.onConnectionInitiated) {
                subscriber.onConnectionInitiated();
            }
        }
    }

    sendMessages(data: any) {
        for (let key in this.subscribers) {
            let subscriber = this.subscribers[key];
            if (subscriber.onPriceUpdate) {
                subscriber.onPriceUpdate(data);
            }
        }
    }
}